<template>
    <div class="main_center" style="margin: 0px 0px; padding-top: 8px;">
        <div class="content">
            <serach-form ref="searchFormRef" :dataList="formList" :form="form" :moreSearchItem="moreSearchItem"></serach-form>
          <div>
          </div>
            <space :left="-16" :right="-16" :bottom="16" />
            <el-row :gutter="16">
                <el-col v-for="item in tableData"
                        :key="item.id"
                        :xs="24" :sm="12" :md="8" :lg="6"
                        class="card-row"
                >
                    <busWitnessCard :item="item" @click="router(item)"></busWitnessCard>
                </el-col>
            </el-row>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            ></pagination>
        </div>
    </div>
</template>

<script>
import { nearSixYearsList } from "@/utils/index";
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination.vue";
import SerachForm from "../../common/components/SerachForm.vue";
import busWitnessCard from './busWitnessCard.vue';
export default {
    name: "busWitnessTable",
    components: {
        space,
        Pagination,
        SerachForm,
        busWitnessCard
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 275,
            dataListLoading: false,
            yearsList: [],
            form: {
                // year: new Date().getFullYear(),
                businessCode: "",
                businessName: "",
                // businessType: "",
                witnessMod: "-1",
                witnessStatus: "-1",
                importantPrj: -1,
                //flowId:"-1",
                flowName: "",
                tradeId: "", // 交易中心ID
                groupMark: "",
                datetimerange: []
            },
            businessType: "",
            groupMark: "",
            witnessModlist: [],
            witnessStatuslist: [],
            businessTypeNamelist: [],
            groupMarklist: [],
            flownodesList: [],
            moreSearchItem: false,
            checkList1: "",
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 0, //总条数
            tableData: [],
            multipleSelection: [],
            user: "", //角色类型
            formData: {},
            transactionCenterList: [],
            //完整展示值
            formList:[
                // {
                //     type:'select',
                //     propName:'year',
                //     labelName:'年份：',
                //     optionList:this.yearsList,
                //     changeClick:'yearsChange',
                //     isShow:true
                // },
                // {
                //     type:'select',
                //     propName:'businessType',
                //     labelName:'业务类型：',
                //     optionList:this.businessTypeNamelist,
                //     changeClick:'seachBtn',
                //     optionLabel:'name',
                //     optionValue:'value',
                //     isShow:'close'
                // },
                {
                    type:'input',
                    propName:'businessCode',
                    labelName:'编号：',
                    isShow:true
                },
                {
                    type:'input',
                    propName:'businessName',
                    labelName:'名称：',
                    isShow:true
                },
                {
                    type:'select',
                    propName:'groupMark',
                    labelName:'项目/标段：',
                    optionList:[{name:'项目', value:'1'},{name:'标段', value:'2'},{name:'多标段', value:'3'}],
                    changeClick:'seachBtn',
                    optionLabel:'name',
                    optionValue:'value',
                    isShow:'close'
                },
                {
                    type:'select',
                    propName:'flowName',
                    labelName:'见证环节：',
                    optionList:this.flownodesList,
                    changeClick:'seachBtn',
                    optionLabel:'name',
                    optionValue:'value',
                    isShow:'close'
                },
                {
                    type:'select',
                    propName:'witnessStatus',
                    labelName:'见证状态：',
                    optionList:this.witnessStatuslist,
                    changeClick:'seachBtn',
                    optionLabel:'name',
                    optionValue:'value',
                    isShow:'close'
                },
                {
                    type:'select',
                    propName:'tradeId',
                    labelName:'所属交易中心：',
                    optionList:this.transactionCenterList,
                    changeClick:'seachBtn',
                    optionLabel:'orgName',
                    optionValue:'id',
                    isShow:'close'
                },
                // {
                //     type:'radio',
                //     propName:'importantPrj',
                //     labelName:'项目关注度：',
                //     optionList:[{label:'全部项目',value:-1},{label:'重点关注项目',value:1},{label:'非重点关注项目',value:0}],
                //     isShow:'close'
                // },
                {
                    type:'date-picker',
                    propName:'datetimerange',
                    labelName:'提交时间：',
                    changeClick:'seachBtn',
                    isShow:'close'
                },
                {
                    type:'button',
                    optionList:[{
                        typePrimary:'primary',
                        isplain:true,
                        size:'small',
                        handleClick:'reflash',
                        btnText:'重置',
                        isShow:true
                    },{
                        typePrimary:'primary',
                        isplain:false,
                        size:'small',
                        handleClick:'seachBtn',
                        btnText:'搜索',
                        isShow:true
                    },{
                        typePrimary:'text',
                        isplain:false,
                        size:'mini',
                        handleClick:'openSearch',
                        btnText:'| 展开',
                        isShow:'open'
                    },{
                        typePrimary:'text',
                        isplain:false,
                        size:'mini',
                        handleClick:'closeSearch',
                        btnText:'| 收起',
                        isShow:'close'
                    }],
                }
            ],
        };
    },
    props: {
        busWitnessTableType: {
            type: String,
            default: ""
        }
    },
    filters: {
        ellipsis(text, num) {
            if (text.length > num) {
                return text.substring(0, num) + "...";
            } else {
                return text;
            }
        }
    },
    watch:{
        yearsList:{
           deep:true,
           handler(val){
                let numberIndex=this.setFormListItem('year')
                if(numberIndex!=null){
                this.formList[numberIndex].optionList= val
                }
           }
        },
        // 交易中心
        transactionCenterList:{
            deep:true,
              handler(val){
                let numberIndex=this.setFormListItem('tradeId')
                if(numberIndex){
                    this.formList[numberIndex].optionList= val
                }
           }
        },
        witnessModlist:{
            handler(val){
                let numberindex=this.setFormListItem('witnessMod')
                if(numberindex){
                this.formList[numberindex].optionList= val
                }
            }
        },
        witnessStatuslist:{
            handler(val){
                let number=this.setFormListItem('witnessStatus')
                if(number){
                  this.formList[number].optionList= val
                }
            }
        },
        businessTypeNamelist:{
            handler(val){
                let number=this.setFormListItem('businessType')
                if(number){
                    this.formList[number].optionList= val
                }
            }
        },
        flownodesList:{
            handler(val){
                let number=this.setFormListItem('flowName')
                if(number){
                    this.formList[number].optionList= val
                }
            }
        },
        moreSearchItem:{
            handler(val){
                this.$nextTick(()=>{
                    let flag=val?'open':'close'
                     this.$refs.searchFormRef.setWidth(flag);
                })
            }
        }
    },
    activated() {
        this.businessType =
            this.busWitnessTableType ||
            window.sessionStorage.getItem("witnessFlowbusinessType");
        // this.reflash();
        this.getDataList();
        // this.getFlownodesList();
    },
    created() {
        this.businessType =
            this.busWitnessTableType ||
            window.sessionStorage.getItem("witnessFlowbusinessType");
        this.getDic("jz_dgwitness_witness_mod");
        this.getDic("jz_dgwitness_witness_status");
        this.getDic('jz_dgwitness_bustype');
        this.getDic(this.businessType === 'GC' ? 'projectWitnessStage' : 'purchaseWitnessStage');
        this.yearsList = nearSixYearsList(this.form.year);
        this.transactionCenterList = JSON.parse(
            sessionStorage.getItem("transactionCenterList")
        );
        this.transactionCenterList.unshift({orgName:'全部',id:''})
        // 初始化 只展示前三个元素 + 控制按钮
        this.formList=this.formList.slice(0,3).concat(this.formList.slice(this.formList.length-1,this.formList.length))
    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
        that.ifmove();
    },
    computed: {},

    methods: {
        setFormListItem(strProp){
            let number=null
            this.formList.forEach((item,index)=>{
                if(item.type!='button'&&item.propName===strProp){
                    number=index
                }
            })
            return number
        },
        openSearch(){
           this.moreSearchItem = true
           // 触发数据监听更新数据
        //    this.formList=[...this.formListCopy]
           this.formList=[...this.$options.data.call(this).formList]
           this.witnessStatuslist=[...this.witnessStatuslist]
           this.flownodesList=[...this.flownodesList]
           this.witnessModlist=[...this.witnessModlist]
           this.transactionCenterList=[...this.transactionCenterList]
           this.yearsList=[...this.yearsList]
            this.businessTypeNamelist = [...this.businessTypeNamelist]
        },
        closeSearch(){
            this.moreSearchItem = false
            this.formList=this.formList.slice(0,3).concat(this.formList.slice(this.formList.length-1,this.formList.length))
        },
        ifmove() {
            let hasBtnPermisson = this.hasBtnPermission(
                "btn_jz_buswitness_" + this.businessType + "del"
            );
            let tableMaxHeight =
                document.documentElement.clientHeight -
                328 +
                (hasBtnPermisson ? 0 : 41);
            this.pageSize = parseInt(tableMaxHeight / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
            // this.getDataList()
        },
        yearsChange(val) {
            this.yearsList = nearSixYearsList(val);
            this.getDataList();
        },
        getDataList() {
            // 获取列表数据
            this.dataListLoading = true;
            this.$http
                .post("/businessFlowWitness/list", {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    // 'filter': this.form
                    filter: {
                        // auditYear: this.form.year,
                        witnessMod:
                            this.form.witnessMod == "-1"
                                ? ""
                                : this.form.witnessMod,
                        importantPrj:
                            this.form.importantPrj == -1
                                ? ""
                                : this.form.importantPrj,
                        witnessStatus:
                            this.form.witnessStatus == "-1"
                                ? ""
                                : this.form.witnessStatus,
                        businessName: this.form.businessName,
                        businessCode: this.form.businessCode,
                        businessType: this.businessType,
                        datasetCode: this.form.flowName,
                        tradeId: this.form.tradeId,
                        groupMark: this.form.groupMark,
                        startTime: this.form.datetimerange[0] ? this.form.datetimerange[0] : "",
                        endTime: this.form.datetimerange[1] ? this.form.datetimerange[1] : ""
                    }
                })
                .then(res => {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.$refs.multipleTable.doLayout();
                    this.dataListLoading = false;
                });
        },

        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        paginationChange(obj) {
            this.pageIndex = obj.page || 1;
            this.pageSize = obj.limit || 5;
            this.getDataList();
        },

        getDic(type) {
            // 获取字典

            this.$http.get("/sys/dictData/getList?type=" + type).then(res => {
                if (res.data.code === "1") {
                    switch (type) {
                        case "jz_dgwitness_witness_mod":
                            this.witnessModlist = res.data.data;
                            // 手动添加表单数据
                            this.witnessModlist.unshift({name:'全部',value:'-1'})

                            break;
                        case "jz_dgwitness_witness_status":
                            this.witnessStatuslist = res.data.data;
                            // 手动添加表单数据
                            this.witnessStatuslist.unshift({name:'全部',value:'-1'})

                            break;
                        case 'jz_dgwitness_bustype':{
                            this.businessTypeNamelist = res.data.data;
                            break;
                        }
                        case 'projectWitnessStage':
                        case 'purchaseWitnessStage':
                        {
                            this.flownodesList = res.data.data;
                            // 手动添加表单数据
                            this.flownodesList.unshift({name:'全部',value:''})
                            break;
                        }
                    }
                }
            });
            this.groupMarklist = [{name:'项目', value:'1'},{name:'标段', value:'2'},{name:'多标段', value:'3'}]
        },

        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //搜索按钮
        seachBtn() {
            this.pageIndex = 1;
            this.getDataList();
        },
        reflash() {
            //刷新按钮
            this.pageIndex = 1;
            this.form.witnessMod = "-1";
            this.form.witnessStatus = "-1";
            this.form.importantPrj = -1;
            this.form.flowName = "";
            this.form.businessName = "";
            this.form.businessCode = "";
            this.form.year = new Date().getFullYear();
            this.yearsList = nearSixYearsList(this.form.year);
            this.form.tradeId = "";
            this.form.datetimerange = [];
            this.form.groupMark = "";
            this.getDataList();
        },

        /* getFlownodesList() {//见证环节下拉框
        this.$http.get('/businessFlowWitness/getFlows?businessType='+this.businessType).then(res=>{
          this.flownodesListData= res.data.data;
          this.total=res.data.total;
          this.$refs.multipleTable.doLayout();
        })
      },*/

        router(item) {
            // 跳转详情
            var id = item.id;
            //window.sessionStorage.setItem("id", id);
            //  window.sessionStorage.setItem("addUpdateIndex",1)

            this.$router.push({
                name: "busWitness_detail",
                query: {
                    businessType: this.businessType,
                    id: id,
                    purchaserMode: item.purchaserMode || ""
                }
            });
        },

        deleteById(item) {
            this.$confirm(`确定要删除该数据?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$http
                    .get(
                        "/businessFlowWitness/delete?id=" +
                            item.id +
                            "&entityId=" +
                            item.entityId /*{
            id: item.id,
            entityId: item.entityId
          }*/
                    )
                    .then(res => {
                        if (res.data.code == "1") {
                            this.$message({
                                type: "success",
                                message: res.data.msg
                            });
                            this.getDataList();
                            //this.getFlownodesList();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.msg
                            });
                        }
                    });
            });
        },
        deleteSelectItem() {
            let ids = new Array();
            let entityIds = new Array();
            this.multipleSelection.forEach(key => {
                ids.push(key.id), entityIds.push(key.entityId);
            });

            if (ids != "" || ids.length > 0) {
                this.$http
                    .get(
                        "/businessFlowWitness/delete?idList=" +
                            ids +
                            "&entityIdList=" +
                            entityIds /*{
            idList: ids,
            entityIdList: entityIds
          }*/
                    )
                    .then(res => {
                        if (res.data.code == "1") {
                            this.$message({
                                type: "success",
                                message: res.data.msg
                            });
                            this.getDataList();
                            // this.getFlownodesList();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.msg
                            });
                        }
                    });
            } else {
                this.$message({
                    type: "error",
                    message: "未选择删除项。"
                });
            }
        }
    },

    destroyed() {
        window.onresize = null;
    }
};
</script>
<style lang="less" scoped>
//列表页面
.main_center {

    .top {
        .seachbtn {
            margin-left: 100px;
            display: flex;
        }
    }
        .card-row {
            margin-bottom: 16px;
            &:last-child {
                margin-bottom: 0px;
            }
        }
}


</style>
